module.exports = __webpack_public_path__ + "img/part3-icon1.037a967a.png";